import { pxToRem } from '@utils/converters';

export const FILTER_POPOVER_MAX_WIDTH = pxToRem(308);
